import { render } from "./Extortion.vue?vue&type=template&id=29474b38"
import script from "./Extortion.vue?vue&type=script&lang=js"
export * from "./Extortion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__